import { styled } from "@mui/material";
import { execGetTenantsForRoleQuery } from "graphqlBase/tenant/__generated__/getTenantsForRole";
import { useGetUserInfo } from "lib/userInfo";
import * as React from "react";
import Autocomplete, { TenantResult, TenantSearch } from "./AutoComplete";
import Props from "./index.d";
import { showNoteOnCarefulInputConditionally } from "pages/UploadCertificate/utils";
import { useState } from "react";

const StyledAutocomplete = styled(Autocomplete)<Props>(({ theme, isUnit }) => ({
  width: isUnit ? "244px" : "",
  "& .MuiOutlinedInput-root": {
    padding: "0px",
  },
}));

const TenantIdForRole: React.FC<Props> = (props) => {
  const {
    role,
    data: { setAndSave },

    isUnit,
    disabled,
  } = props;
  const isEdit = Object.keys(props.raftVariables).includes("id");
  const userInfo = useGetUserInfo();
  const [showNoteOnCarefulInput, setShowNoteOnCarefulInput] = useState(false);
  const search: TenantSearch = ({ inputValue }, callback) => {
    execGetTenantsForRoleQuery({
      variables: { role, inputValue, approvalStatus: ["APPROVED", "WITHOUT_EA_APPROVAL"] },
    }).then((res) => {
      const tenants = res.data.tenants?.items ?? [];
      const tenantResults: TenantResult[] = tenants.reduce((acc, tenant) => {
        // exclude placeHolder certification body
        if (tenant.id !== "28d2afd0-4db5-5a06-b7d0-542eb13f528a") {
          acc.push({
            key: tenant.id,
            label: tenant.tenantName,
          });
        }
        return acc.sort((a, b) => a.label.localeCompare(b.label));
      }, [] as TenantResult[]);

      callback(tenantResults);
    });
  };

  React.useEffect(() => {
    if (userInfo?.role === role) {
      //@todo remove default value
      setAndSave(userInfo?.tenantId);
    }
  }, [userInfo, role, setAndSave]);
  return (
    <>
      {showNoteOnCarefulInputConditionally({ condition: showNoteOnCarefulInput })}
      <StyledAutocomplete
        {...props}
        search={search}
        disabled={role === userInfo?.role || isEdit || disabled}
        isUnit={isUnit}
        isEdit={isEdit}
        setShowNoteOnCarefulInput={setShowNoteOnCarefulInput}
      />
    </>
  );
};

export default TenantIdForRole;
